import { Box, Dialog, DialogContent, DialogTitle, Typography, useTheme } from "@mui/material";
import CustomCircularProgress from "@components/CustomCircularProgress";
import { ErrorOutline } from "@mui/icons-material";
import { Button } from "@mui/material";

export type LoaderConsultaCiecProps = {
  open: boolean;
  closeModal: (isError?: boolean) => void;
  isValidCiec: boolean | null;
};

const LoaderConsultaCiec = ({ open, closeModal, isValidCiec }: LoaderConsultaCiecProps) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
    >
      <DialogTitle>
        {isValidCiec === false ? (
          <Typography color={theme?.palette?.primary?.dark} textAlign={"center"} fontSize={"20px"} fontWeight={700}>
            La CIEC ingresada
            <br />
            es inválida.
          </Typography>
        ) : (
          <Typography color={theme?.palette?.primary?.dark} textAlign={"center"} fontSize={"20px"} fontWeight={700}>
            Estamos estableciendo
            <br />
            conexión con el SAT
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        {isValidCiec === false ? (
          <>
            <Typography color={theme?.palette?.primary?.dark} textAlign={"center"} fontSize={"18px"} fontWeight={400}>
              Inténtalo de nuevo.
            </Typography>
            <Box mt={2} mb={2} display="flex" justifyContent="center">
              <ErrorOutline style={{ color: "red", fontSize: "40px" }} />
            </Box>

            <Box mt={2} mb={2} display="flex" justifyContent="center">
              <Button variant="default" onClick={() => closeModal(true)}>
                Cerrar
              </Button>
            </Box>
          </>
        ) : (
          <>
            <Box mt={2} mb={2} display="flex" justifyContent="center">
              <CustomCircularProgress size={150} />
            </Box>

            <Box mt={2} mb={2}>
              <Typography color={theme?.palette?.primary?.main} fontSize={"20px"} fontWeight={700} textAlign={"center"}>
                Esto puede demorar unos
                <br />
                minutos
              </Typography>
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default LoaderConsultaCiec;
